import React from 'react';

export interface SwitchUserTypeContextInterface {
  /**
   * The type of the impersonated user
   */
  switchUserType: string | undefined;
  /**
   * Callback to clear switchUserType
   */
  clearSwitchUserType: () => void;
}

/**
 * Switch user context provides the type of the user that is switched to.
 *
 * @author Lucas Fernandez
 */
const SwitchUserTypeContext = React.createContext<SwitchUserTypeContextInterface>({
  switchUserType: undefined,
  clearSwitchUserType: () => null
});

export default SwitchUserTypeContext;
